import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeModeProvider } from './ThemeModeContext';
import { AuthProvider } from './AuthContext';
import { AnalysisProvider } from './AnalysisContext';
import AuthWrapper from './AuthWrapper';
import AppShell from './components/AppShell';
import SSATAnalyzer from './SSATAnalyzer';
import DetailedGuide from './DetailedGuide';
import History from './pages/History';
import Shared from './pages/Shared';
import Admin from './pages/Admin';
import './i18n'; // Import i18n configuration

// Routes (2026-10 redesign): the analyzer, history, shared-with-me and the admin-only customer uploads each have a page.
function App() {
  return (
    <ThemeModeProvider>
      <AuthProvider>
        <Router>
          <AuthWrapper>
            <AnalysisProvider>
              <Routes>
                <Route element={<AppShell />}>
                  <Route path="/" element={<SSATAnalyzer />} />
                  <Route path="/history" element={<History />} />
                  <Route path="/shared" element={<Shared />} />
                  <Route path="/admin" element={<Admin />} />
                  <Route path="/detailed-guide" element={<DetailedGuide />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Route>
              </Routes>
            </AnalysisProvider>
          </AuthWrapper>
        </Router>
      </AuthProvider>
    </ThemeModeProvider>
  );
}

export default App;
